import { createContext } from "react";

import { ClaimHelper } from "@modules/acc/screens/claim/context/ClaimHelper.ts";

export const ClaimContext = createContext<ClaimHelper>({} as ClaimHelper);
